<br />
<div class="form-container">
  <div  *ngIf="externalUser?.accountType == 1">
    <div class="form-row">
      <div class="form-col">
        <mat-label class="title-label">Who has the Reporting responsibility for this property ?
        </mat-label>
      </div>
    </div>
    <div class="form-row" >
      <div class="form-col">
        <section class="example-section">
          <mat-checkbox class="primary" [(ngModel)]="isOwner" class="example-margin">Owner</mat-checkbox>
          <mat-checkbox class="primary" (change)="showManager($event)" [(ngModel)]="isManager"
            class="example-margin">Property Management Company</mat-checkbox>
        </section>
      </div>
    </div>
  </div>


  <div class="form-row">
    <div class="form-col">
      <div *ngIf="isManager" style="max-height: 400px; overflow-y: scroll" class="row">
        <div class="Frame106" style="
                width: 100%;
                height: 100%;
                border-radius: 8px;
                border: 1px #e0e0e0 solid;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                gap: 24px;
                display: inline-flex;
              ">
          <div class="row" style="
                  align-self: stretch;
                  height: 56px;
                  padding-left: 16px;
                  padding-right: 16px;
                  justify-content: flex-end;
                  align-items: flex-end;
                  gap: 8px;
                  display: inline-flex;
                ">
            <div class="Frame152" style="
                    flex: 1 1 0;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: flex-start;
                    gap: 8px;
                    display: inline-flex;
                  ">
              <div class="Formlabel" style="
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      display: flex;
                    ">
                <div class="Label" style="
                        color: rgba(0, 0, 0, 0.87);
                        font-size: 16px;
                        font-family: Roboto;
                        font-weight: 400;
                        line-height: 24px;
                        letter-spacing: 0.15px;
                        word-wrap: break-word;
                      ">
                  Add the property management companies here
                </div>
              </div>
            </div>

            <button (click)="addCompany()" mat-stroked-button mat-button class="button-stepper-back">
              ADD COMPANY
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <div class="Frame162149" style="
                  align-self: stretch;
                  height: 128px;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: flex-start;
                  display: flex;
                ">
            <table mat-table [dataSource]="companyDataSource">
              <!-- ID Column -->
              <ng-container matColumnDef="name">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  Company name
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.companyName }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="streetAddress">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  Street Address
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.streetAddress }}
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="aptUnitSuite">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  Apt/unit/suite
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.aptUnitSuite }}
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="city">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  City
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.city }}
                </td>
              </ng-container>
              <!-- Email Column -->
              <ng-container matColumnDef="state">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  State
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.stateName }}
                </td>
              </ng-container>
              <!-- Email Column -->
              <ng-container matColumnDef="zipCode">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  Zip Code
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.zipCode }}
                </td>
              </ng-container>
              <!-- Email Column -->
              <ng-container matColumnDef="action">
                <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                  Actions
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <mat-icon class="icon-pointer" style="color: #2196f3" (click)="editCompany(element)"
                    aria-label="Edit">edit</mat-icon>
                  <mat-icon (click)="removeCompany(i)" style="color: red" class="icon-pointer"
                    aria-label="Delete">delete</mat-icon>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="managementcompaniesColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: managementcompaniesColumns"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-row">
    <form [formGroup]="rentalPropertyReporting">
      <div class="form-container">
        <div class="form-row">
          <div class="form-col">
            <mat-label class="title-label">Are you using a tax reporting representative ?
            </mat-label>
          </div>
        </div>
        <div class="form-row">
          <div class="form-col">
            <mat-radio-group class="primary" formControlName="isUsingTaxRepresentative" aria-label="Select an option">
              <mat-radio-button class="primary" [value]="true" (click)="showAndHideTaxForm(true)">Yes</mat-radio-button>
              <mat-radio-button class="primary" [value]="false"
                (click)="showAndHideTaxForm(false)">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div *ngIf="showTaxRepresentativeForm" class="form-row">
          <div class="form-col">
            <div class="form-row">
              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>First name</mat-label>
                  <input matInput formControlName="taxRepresentativeFirstName" placeholder="First name" />
                  <mat-error> First name is required</mat-error>
                </mat-form-field>
              </div>
              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>Last name</mat-label>
                  <input matInput formControlName="taxRepresentativeLastName" placeholder="Last name" />
                  <mat-error>Last name is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>Email address</mat-label>
                  <input matInput formControlName="taxRepresentativeEmail" placeholder="Email address" />
                  <mat-error
                    *ngIf="this.rentalPropertyReporting.get('taxRepresentativeEmail')?.errors?.['email'] && (rentalPropertyReporting.get('taxRepresentativeEmail')?.touched)">Email
                    address is invalid</mat-error>

                  <mat-error
                    *ngIf="this.rentalPropertyReporting.get('taxRepresentativeEmail')?.errors?.['required'] && (rentalPropertyReporting.get('taxRepresentativeEmail')?.touched)">Email
                    address is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>Phone number</mat-label>
                  <input matInput formControlName="taxRepresentativePhoneNumber" placeholder="Phone number" />
                  <mat-error
                    *ngIf="this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.errors?.['pattern'] && (rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.touched)">Phone
                    number is invalid</mat-error>

                  <mat-error
                    *ngIf="this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.errors?.['required'] && (rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.touched)">Phone
                    number is required</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="form-col">
            <div class="form-row">
              <div class="form-col">
                <mat-form-field class="mat-form-field-100" appearance="outline">
                  <mat-label>Tax reporting representative street address</mat-label>
                  <input matInput class="form-outline form-control"
                    placeholder="Tax reporting representative street address"
                    formControlName="taxRepresentativeStreetAddress" [matAutocomplete]="auto" />
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                      (onSelectionChange)="selectPlace(suggestion)">
                      {{ suggestion.description }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error>
                    Tax reporting representative street address is
                    required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>Apt/Unit/Suite</mat-label>
                  <input matInput formControlName="taxRepresentativeAptUnitSuite"
                    placeholder="Apt/Unit/Suite" />
                  <mat-error> Apt/Unit/Suite is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>City</mat-label>
                  <input matInput formControlName="taxRepresentativeCity" placeholder="City" />
                  <mat-error> City is required</mat-error>
                </mat-form-field>
              </div>

              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>State</mat-label>

                  <mat-select formControlName="taxRepresentativeState" placeholder="State">
                    @for (state of states; track state) {
                    <mat-option [value]="state.id">{{ state.name }}</mat-option>
                    }
                  </mat-select>
                  <mat-error> State is required</mat-error>
                </mat-form-field>
              </div>

              <div class="form-col">
                <mat-form-field appearance="outline">
                  <mat-label>Zip Code</mat-label>
                  <input matInput formControlName="taxRepresentativeZipCode" placeholder="Zip Code" />
                  <mat-error
                    *ngIf="this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.errors?.['pattern'] && (rentalPropertyReporting.get('taxRepresentativeZipCode')?.touched)">Zip
                    code is invalid</mat-error>

                  <mat-error
                    *ngIf="this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.errors?.['required'] && (rentalPropertyReporting.get('taxRepresentativeZipCode')?.touched)">Zip
                    Code is required</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="showTaxRepresentativeForm" class="form-row">
          <mat-label class="title-label">Send all correspondence to</mat-label>
        </div>
        <div *ngIf="showTaxRepresentativeForm" class="form-row">
          <section class="example-section">
            <mat-checkbox class="primary" formControlName="sendToOwner" class="example-margin">Owner</mat-checkbox>
            <mat-checkbox class="primary" formControlName="sendToReportingRep" class="example-margin">Tax reporting
              representative</mat-checkbox>
          </section>
        </div>
      </div>
    </form>
  </div>
</div>